class Scroller extends HTMLElement {
  constructor() {
    super();

    // Make an array from the elements within `.scroller-inner`
    this.inner = this.querySelector('.scroller__inner');
    this.content = Array.from(this.inner.children);
  }

  connectedCallback() {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.prepareContent();
      this.addAnimation();
    }
  }

  disconnectedCallback() {}

  prepareContent() {
    // Measure the total width of the current content
    let contentWidth = this.content.reduce((acc, item) => {
      return acc + item.offsetWidth;
    }, 0);

    // We'll compare to the scroller's own width (you could also compare to window.innerWidth if desired)
    const containerWidth = this.offsetWidth;

    // If the content width is smaller than the container's width,
    // duplicate content until it is large enough.
    while (contentWidth < containerWidth) {
      this.content.forEach((item) => {
        const cloned = item.cloneNode(true);
        cloned.setAttribute('aria-hidden', true);
        this.inner.appendChild(cloned);
        contentWidth += item.offsetWidth;
      });
    }
  }

  addAnimation() {
    // add data-animated="true" to every `.scroller` on the page
    this.setAttribute('data-animated', true);

    // For each item in the array, clone it
    // add aria-hidden to it
    // add it into the `.scroller-inner`
    this.content.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute('aria-hidden', true);
      this.inner.appendChild(duplicatedItem);
    });
  }
}

customElements.define('x-scroller', Scroller);
